import { MessageBox,Loading } from 'element-ui'

export const _confirm = (message,ensureFn,cancelFn) => {
  MessageBox.confirm(message,'提示', { center: true, type: 'warning' })
    .then(() => {
      ensureFn()
    })
    .catch(() => {
      if (cancelFn) cancelFn();
    })
}
export const _alert = (message,ensureFn,type = 'success') => {
  MessageBox.alert(message,'提示', {
    center: true,
    type,
    callback: () => {
      if (ensureFn) ensureFn()
    }
  })
}

export const _loading = (config) => {
  let defaultConfig = {
    lock: true,
    text: config?config.text:'加载中...',
    spinner: 'el-icon-loading',
    background: 'rgba(255, 255, 255, 0.7)',
  }
  return Loading.service({...defaultConfig,...config});
}

